import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-strategy-catalog',
  templateUrl: './skeleton-strategy-catalog.component.html',
  styleUrls: ['./skeleton-strategy-catalog.component.scss'],
  standalone: false,
})
export class SkeletonStrategyCatalogComponent implements OnInit {
  @Input() numOfCards: number = 12;
  skeletonItems: number[] = [];

  constructor() {}

  ngOnInit(): void {
    this.skeletonItems = new Array(this.numOfCards).fill(0);
  }
}
